import { Action } from '@occc-app/rootRedux';

import types, { GLOBAL_LIMIT, MEMBERSHIP_LIMIT, State } from './types';

import { default as offerTypes } from '../../../redux/types';

export const initialState: State = {
  globalLimit: {
    type: GLOBAL_LIMIT,
    active: false,
    limit: 0,
    error: null,
    errorMessages: [],
    id: '',
    dirty: false,
    submitting: false,
  },
  membershipLimit: {
    type: MEMBERSHIP_LIMIT,
    active: false,
    limit: 0,
    error: null,
    errorMessages: [],
    id: '',
    dirty: false,
    submitting: false,
  },
  error: null,
  errorMessages: [],
  requesting: true,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case types.LIMIT_COMPONENT_ERR:
      const { limitType: limitTypeERR, error, errorMessages } = action;
      return {
        ...state,
        [limitTypeERR]: {
          ...state[limitTypeERR],
          error,
          errorMessages,
        },
      };
    case types.LIMIT_COMPONENT_OK:
      const { limitType: limitTypeOK, id } = action;
      return {
        ...state,
        [limitTypeOK]: {
          ...state[limitTypeOK],
          id,
          error: null,
          errorMessages: [],
          dirty: false,
        },
      };
    case types.LIMIT_COMPONENTS_ERR:
      const { error: limitComponentsError, errorMessages: limitComponentsErrorMessages } = action;
      return {
        ...state,
        error: limitComponentsError,
        errorMessages: limitComponentsErrorMessages,
      };
    case types.LIMIT_COMPONENTS_OK:
      return {
        ...state,
        error: null,
        errorMessages: [],
      };
    case types.LIMIT_CONFIGURATION_UPDATE:
      const { limitConfigurationKey } = action;
      return {
        ...state,
        [limitConfigurationKey]: {
          ...(state as any)[limitConfigurationKey],
          [action.key]: action.value,
          dirty: true,
        },
      };
    case types.LIMIT_TOGGLE_UPDATE:
      const { limitConfigurationKey: toggledConfiguration } = action;
      return {
        ...state,
        [toggledConfiguration]: {
          ...(state as any)[toggledConfiguration],
          dirty: true,
          active: !(state as any)[toggledConfiguration].active,
        },
      };
    case types.REQUEST_LIMIT:
      return {
        ...state,
        [action.limitType]: {
          ...state[action.limitType],
          id: action.id,
          error: null,
          errorMessages: [],
          dirty: true,
        },
      };
    case types.REQUEST_LIMIT_OK:
      const selectedLimit = action.selectedLimit.type;
      return {
        ...state,
        [selectedLimit]: {
          ...state[selectedLimit],
          error: null,
          errorMessages: [],
          dirty: false,
          ...action.selectedLimit,
        },
      };
    case types.REQUEST_LIMITS_OK:
      return {
        ...state,
        requesting: false,
      };
    case types.RESET_INITIAL_LIMITS_STATE:
      return {
        ...state,
        ...action.limits,
      };
    case offerTypes.CLEAR_OFFER_COMPONENT_STATE:
      return initialState;
  }
  return state;
}
